import React, { useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "./HeroSection-ImageDesign.css";

const HeroSectionImageDesign = () => {
  const videoId = "TSv9xk0M6Ag";
  const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;
  const thumbnailUrl = "/assets/images/meetup-glimps-thumbnail.png";

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <section className="hero-image-design-section">
      <div className="hero-image-design-bottom-bg"></div>

      <div className="container position-relative z-index-1">
        {/* Top Text Content */}
        <div className="row hero-image-design-content justify-content-center text-center">
          <div className="col-lg-10">
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="hero-image-design-text-left"
            >
              <div className="hero-image-design-badge">
                
              </div>
              <h1 className="hero-image-design-title">
                Best Moments from <br /><span>MSB Association Annual Meet 2026</span>
              </h1>
              <div className="hero-image-design-actions">
                <button onClick={openModal} className="btn-hero-primary border-0">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" style={{ marginRight: '10px' }}>
                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                  </svg>
                  Watch on YouTube
                </button>
               
              </div>
            </motion.div>
          </div>
        </div>

        {/* Bottom Video Box */}
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
              className="hero-image-design-video-wrapper"
              onClick={openModal}
              style={{ cursor: 'pointer' }}
            >
              <div className="hero-image-design-video-link">
                <img src={thumbnailUrl} alt="MSB Video Thumbnail" className="hero-image-design-video-img" />
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Modal for Video Player */}
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="video-responsive">
              <iframe
                width="853"
                height="450"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&controls=1`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
              />
            </div>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroSectionImageDesign;
